import { useDispatch } from 'react-redux'
import { AppDispatch } from 'redux/store'
/**
 * Hook for using the dispatch function correctly typed 
 */
export const useAppDispatch = () => useDispatch<AppDispatch>()

